import Vue from "vue";
import Router from "vue-router";
import translations from "@/translations.json";
// import moment from "moment";
Vue.use(Router);

const baseTitle = document.title;
const t = translations.header;

export const router = new Router({
  // mode: "history",
  // base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      component: () => import("@/views/Main.vue"),
      children: [
        {
          path: "/",
          name: "Login",
          component: () => import("@/components/login.vue"),
          meta: { title: "Login" }
        },
        {
          path: "/home",
          name: "Home",
          component: () => import("@/views/Home.vue"),
          meta: { title: t.home }
        },
        {
          path: "/administer",
          name: "Administer",
          component: () => import("@/views/Administer.vue"),
          meta: { title: t.administer }
        },
        {
          path: "/tip-os",
          name: "Tips",
          component: () => import("@/views/Tips.vue"),
          meta: { title: t.tipOs }
        },
        {
          path: "/about",
          name: "About",
          component: () => import("@/views/About.vue"),
          meta: { title: t.about }
        }
      ]
    },
    //otherwise redirect to home
    { path: "*", redirect: "/" }
  ],
  mode: "history"
});

router.beforeEach((to, from, next) => {
  if (to.fullPath.includes("#access_token")) return;

  //redirect to login page if not logged in and trying to access a restricted page
  const publicPages = ["/"];
  const authRequired = !publicPages.includes(to.path);
  const loggedIn =
    JSON.parse(localStorage.getItem("user")) ||
    JSON.parse(sessionStorage.getItem("user"));
  // const loginExpired = moment(loggedIn.expires_on).isAfter();
  if (authRequired && !loggedIn) {
    return next("/");
  }

  next();
});

router.afterEach(to => {
  document.title =
    to.meta && to.meta.title ? `${baseTitle} - ${to.meta.title}` : baseTitle;
});
